{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "Crazy Wheel",
  "description": "A unique fortune wheel game with different multipliers and rewards.",
  "url": "https://6cs.fail/en/crazy-wheel"
}
